import { Popconfirm, Button, message, ButtonProps } from 'antd';
import { useTranslate } from '@tolgee/react';
import { confirmReturn } from 'services/api/return';
import { getApiErrorCodeMsg } from 'services/api/utils/errorCode';
import { useRequest } from 'ahooks';

interface TikTokConfirmChangeProps {
  externalStoreId: string;
  orderSn: string;
  returnSn: string;
  platform?: string;
  refreshList?: () => void;
  btnProps?: ButtonProps;
}

export const TikTokConfirmChange = (props: TikTokConfirmChangeProps) => {
  const { t } = useTranslate();
  const { btnProps, externalStoreId, orderSn, returnSn, platform, refreshList } = props;

  const { loading: confirmChangeLoading, runAsync: confirmChangeSubmit } = useRequest(
    () =>
      confirmReturn({
        externalStoreId,
        externalTradeId: orderSn,
        returnSn,
        externalType: platform,
        operate: 'CONFIRM_CHANGE',
      }),
    {
      manual: true,
      onSuccess() {
        refreshList?.();
      },
      onError(err: any) {
        message.error(getApiErrorCodeMsg(err.response));
      },
    },
  );

  return (
    <Popconfirm
      title={t('确认同意买家的换货申请吗')}
      onConfirm={confirmChangeSubmit}
      okButtonProps={{ loading: confirmChangeLoading }}
    >
      <Button {...btnProps}>{t('同意换货')}</Button>
    </Popconfirm>
  );
};
